import Browser from 'browser';
import LoggerFactory from 'logger-factory';

const Logger = LoggerFactory.create('[Superwidget SDK]', () => false);
const DEFAULT_THEME = 'default';
const DEFAULT_SUPERWIDGET_HOST = 'https://superwidget-assets.gowatchit.com';
const SUPERWIDGET_SCRIPT_ID = 'gwijslib';

export default class SuperwidgetSDK {
  static initializeSDK(apiKey, options = {}) {
    const browserWindow = Browser.getWindow();
    const browserDocument = Browser.getDocument();
    const theme = options.theme || DEFAULT_THEME;
    const superwidgetHost = options.superwidgetHost || DEFAULT_SUPERWIDGET_HOST;

    if (browserWindow.GWI !== undefined) {
      Logger.warn('GWI global variable is already defined. Will not add the superwidget SDK.');
      return;
    }

    browserWindow.GWI = {
      config: {
        apiKey,
        theme,
      },
    };

    const superwidgetScriptTag = browserDocument.createElement('script');
    const firstScriptTag = browserDocument.getElementsByTagName('script')[0];

    superwidgetScriptTag.id = SUPERWIDGET_SCRIPT_ID;
    superwidgetScriptTag.src = `${superwidgetHost}/gwi.js`;

    firstScriptTag.parentNode.insertBefore(superwidgetScriptTag, firstScriptTag);
  }

  static openModal(watchableType, watchableId, flavor, options = {}) {
    const parameters = {
      type: watchableType,
      id: watchableId,
      flavor,
      ...options,
    };

    console.log('openModal', parameters)
    Browser.getWindow().GWI.showModal(parameters);
  }
}



// WEBPACK FOOTER //
// ./~/superwidget-sdk/src/superwidget-sdk.js